import { render, staticRenderFns } from "./PaymentFormDescription.vue?vue&type=template&id=790595b8&scoped=true&"
import script from "./PaymentFormDescription.vue?vue&type=script&lang=ts&"
export * from "./PaymentFormDescription.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentFormDescription.vue?vue&type=style&index=0&id=790595b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790595b8",
  null
  
)

export default component.exports